import styles from './ButtonAction.module.css'
import {
  Button
} from '@mui/material'

const ButtonAction = ({
  children,
  ...others
}) => {
  return (
    <Button
      variant="contained"
      className={styles.action}
      {...others}
    >
      {children}
    </Button>
  )
}

export default ButtonAction
